module.exports = __webpack_public_path__ + "static/media/bindEnterprise1.2666f6c5.png";